import { Grid, TextField, Button, Typography } from "@material-ui/core";
import { PrimaryButton } from "../components-atoms";
import GeneralModal from "./GeneralModal";
import { useState } from "react";


interface SubscriptionActivateModalProps {
	isVisible: boolean;
	close: () => void;
	activate: (numberOfCredits: number, monthlySubPrice: number) => void;
  source?: string;
}

export function SubscriptionActivateModal({ isVisible, close, activate, source }: SubscriptionActivateModalProps): JSX.Element {
	const [numberOfCredits, setNumberOfCredits] = useState<string>("0");
	const [monthlySubPrice, setMonthlySubPrice] = useState<string>("0.0");

	function isFloat(val: string) {
		var floatRegex = /^[0-9]+(\.)?[0-9]*$/;
		if (!floatRegex.test(val)) return false;
		if (isNaN(parseFloat(val))) return false;
		return true;
	}

	const hasInvalidCredits = parseInt(numberOfCredits) % 1 !== 0;
	const hasInvalidPrice = !isFloat(monthlySubPrice) || parseFloat(monthlySubPrice) < 0.0;

	return (
		<GeneralModal
      title={source === "merchant" ? "Set subscription price" : "Activate subscription"}
			description="Please set the monthly price (excl. VAT) and the number of free deliveries."
			visible={isVisible}
			onClose={() => close()}
			modalWidth="560px"
		>
			<GeneralModal.ContentArea>
				<Grid container>
					<Grid item xs={12}>
						<TextField
							fullWidth
							variant="outlined"
							margin="normal"
							id="NrOfFreeDeliveries"
							placeholder="Number of free deliveries"
							label="Number of free deliveries"
							name="CategoryName"
							value={numberOfCredits}
							onChange={v => setNumberOfCredits(v.target.value)}
						/>
					</Grid>
					{hasInvalidCredits && <Grid item xs={12}>
						<Typography variant="caption" color="error">
							Please enter a valid integer for credit amount.
						</Typography>
					</Grid>}
					<Grid item xs={12}>
						<TextField
							fullWidth
							variant="outlined"
							margin="normal"
							id="MonthlySubscriptionPrice"
							placeholder="Monthly subscription price"
							label="Monthly subscription price"
							name="MonthlySubscriptionPrice"
							value={monthlySubPrice}
							onChange={v => setMonthlySubPrice(v.target.value)}
							error={hasInvalidPrice}
						/>
					</Grid>
					{hasInvalidPrice && <Grid item xs={12}>
						<Typography variant="caption" color="error">
							Please enter a valid price.
						</Typography>
					</Grid>
					}
				</Grid>
			</GeneralModal.ContentArea>
			<GeneralModal.ButtonArea>
				<Button onClick={() => close()}>
					<Typography
						variant="button"
						component="p"
						color="primary">
						Cancel
					</Typography>
				</Button>
				<PrimaryButton
					title="Activate"
					onClick={() => { if (!hasInvalidPrice && !hasInvalidCredits) activate(parseInt(numberOfCredits), parseFloat(monthlySubPrice)); }}
					disabled={hasInvalidPrice}
				/>
			</GeneralModal.ButtonArea>
		</GeneralModal>
	);
}
